import { Component, EventEmitter, OnDestroy, OnInit } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../helper/userpilot-reloader.component';

@Component({
  selector: 'app-login-signup-language-buttons',
  templateUrl: './login-signup-language-buttons.component.html',
  styleUrls: ['./login-signup-language-buttons.component.scss']
})
export class LoginSignupLanguageButtonsComponent extends UserpilotReloader implements OnInit, OnDestroy {
  selectedLanguage?: string;
  onDestroyNotifier = new EventEmitter();

  constructor(private translationService: AnessaTranslationService) {
    super();
  }

  ngOnInit(): void {
    this.selectedLanguage = this.translationService.getCurrentLang();

    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.selectedLanguage = this.translationService.getCurrentLang();
    });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }

  onLanguageSelect(language: string) {
    this.translationService.changeLanguage(language);
  }

}
